<template>
    <div class="basic_wrap">
        <div class="red_top_bg">
            <div class="back_left" @click="$router.back()"></div>
            <div class="big_tit">{{ $t('lang.量化记录') }}</div>
        </div>
       <div class="cont">
           <div class="tab">
               <div class="tabItem" :class="{'active': tabIndex === 0}" @click="changeTab(0)">{{ $t('lang.全部') }}</div>
               <div class="tabItem" :class="{'active': tabIndex === 1}" @click="changeTab(1)">{{ $t('lang.进行中') }}</div>
               <div class="tabItem" :class="{'active': tabIndex === 2}" @click="changeTab(2)">{{ $t('lang.已结束') }}</div>
           </div>
           <van-empty :description="$t('orders.noOrders')" v-if="empty"/>
           <div class="scrollBox">
               <div class="notes_box" v-if="!empty" v-for="i in data.list">
                   <p class="timer">
                       {{ i.time }}
                       <span class="ing" v-if="i.status==0">{{ $t('orders.unfinish') }}</span>
                       <span class="finish" v-if="i.status==1">{{ $t('orders.finish') }}</span>
                   </p>
                   <div class="item_div1">
                       <p>
                           {{ i[lang] }}
                       </p>
                   </div>
                   <div class="item_div2">
                       <div class="item_min">
                           <p>{{ $t('utils.moneyMark') }}{{ parseInt(i.money) }}</p>
                           <p>{{ $t('utils.investmentAmount') }}</p>
                       </div>
                       <div class="item_rate">
                           <p>{{ $t('utils.moneyMark') }}{{ (i.money * i.rate / 100 * i.day).toFixed(2) }}</p>
                           <p>{{ $t('utils.income') }}</p>
                       </div>
                       <div class="item_day">
                           <p>{{ i.day }}{{ returnCy(i.sy_ms) }}</p>
                           <p>{{ $t('utils.cycle') }}</p>
                       </div>
                   </div>
               </div>
           </div>
       </div>
    </div>
</template>

<script>
import Vue from "vue";
import {
    Empty
} from "vant";

import Fetch from "../../utils/fetch";

Vue.use(Empty);

export default {
    name: "order",
    data() {
        return {
            lang: this.$i18n.locale || "en_us",
            data: {},
            empty: false,
            tabIndex: 0,
        };
    },
    created() {
        this.$parent.footer("user", false);
    },
    mounted() {
        this.start();
    },
    methods: {
        returnCy(ms){
            let msg = ''
            switch (ms) {
                case 0:
                    msg = this.$t('utils.day')
                    break;
                case 1:
                    msg = this.$t('lang.小时');
                    break;
                case 2:
                    msg = this.$t('lang.天后结算');
                    break;
                default:
                    break;
            }
            return msg;
        },
        changeTab(i){
            if(i === this.tabIndex)return;
            this.tabIndex = i;
            this.start()
        },
        start() {
            Fetch("/user/order", {status: this.tabIndex}).then((r) => {
                this.data = r.data;
                r.data.list.length == 0 ?
                    (this.empty = true) :
                    (this.empty = false);
            });
        },
        wan(str) {
            var num = parseFloat(str);
            if (num > 99999) {
                return `${(num / 10000).toFixed(2)}万`;
            } else {
                return str || 0;
            }
        },
        lookHT(id) {
            this.$router.push("/contract/" + id);
        },
    },
};
</script>

<style lang="less" scoped>
.red_top_bg {
  height: 44px;
  background-size: 100% 100%;
  position: fixed;
  z-index: 15;
  color: rgb(239, 216, 196);
  background: rgb(35, 29, 29);
}
.cont{
  height: calc(100vh - 44px);
  margin-top: 44px;
  background: url("../../assets/img/home-bg.jpg") no-repeat;
  background-size: 100% 100%;
  .tab{
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    padding: 10px 6px;
    .tabItem{
      border: 1px solid rgba(84,57,46,1);
      padding: 10px 24px;
      color: rgb(152, 135, 128);
      background: rgb(35, 29, 29);
      border-radius: 0.375rem;
      overflow: hidden;
    }
    .active{
      color: rgb(70, 44, 26);
      background: linear-gradient(0deg, rgb(182, 145, 117) 0%, rgb(244, 222, 201) 100%);
    }
  }
}

.notes_box {
  width: 100%;
  padding-bottom: 2px;
  box-shadow: 0px 2px 9px 2px rgba(160, 160, 160, 0.15);
  margin-bottom: 10px;
  border: 1px solid #917E70;
  border-radius: 0.59375rem;
  background: #4B4241;
  color: #f5e7db;

  .timer {
    padding: 12px 14px;
    font-size: 12px;
    color: #f5e7db;
    border-bottom: 1px solid #ececec;
    display: flex;
    justify-content: space-between;
    align-items: center;

    span {
      font-style: normal;
      padding: 5px;
      border-radius: 5px;
      color: #FFFFFF;
    }

    .ing {
      background: #3775f4;
    }

    .finish {
      font-style: normal;
      background: #07c160;
    }
  }

  .item_div1 {
    display: flex;
    justify-content: space-between;
    padding: 15px 10px;

    p:nth-child(1) {
      width: 100%;
      font-weight: bold;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

    }
  }

  .item_div2 {
    display: flex;
    justify-content: space-between;
    text-align: center;
    margin-bottom: 10px;

    div {
      width: 33.33%;

      p {
        padding: 5px 0;
      }
    }

    .item_rate {
      p:nth-child(1) {
        font-weight: bold;
        font-size: 14px;
        color: #FF0000;

      }

      p:nth-child(2) {
        color: #999;
      }
    }

    .item_day {
      p:nth-child(1) {
        font-weight: bold;
        font-size: 14px;

      }

      p:nth-child(2) {
        color: #999;
      }
    }

    .item_min {
      p:nth-child(1) {
        font-weight: bold;
        font-size: 14px;

      }

      p:nth-child(2) {
        color: #999;
      }
    }
  }
}

.scrollBox {
  width: 96%;
  margin: 0 auto;
}
</style>
